@if (message) {
	<div id="snackbar" [ngClass]="{ visible: isVisible }" (click)="close()">
		<div>
			<span [translate]="message.translate" [translateParams]="message.translateParams"></span>
		</div>
	</div>
}
